export enum PageLanguage {
  sv = 'sv',
  en = 'en',
  da = 'da',
}

export const isValidPageLanguage = (
  language: string
): language is PageLanguage =>
  Object.values<string>(PageLanguage).includes(language);
